module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/off_icon-3b270d69239f2fb561069a9ff9f6f12b.svg";